function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;


//////////////////
// WEBPACK FOOTER
// ./~/.deno/@babel+runtime@7.26.0/~/@babel/runtime/helpers/assertThisInitialized.js
// module id = 166
// module chunks = 0